import { resolveTimeframeMs } from "../history/historyDataUtils";
export class DataProviderAdapterWrapper {
    provider;
    label = "data-provider-wrapper";
    constructor(provider) {
        this.provider = provider;
    }
    getSourceSemantics() {
        return {
            supportedTimeframes: ["1m", "5m", "15m", "1h", "4h", "1D", "1W", "1M"],
            supportsStreaming: true,
        }; // ARC-1-keep: legacy bridge
    }
    async fetchBarsInRange(symbol, timeframe, from, to, _chartId) {
        const bars = await this.provider.fetchBars(symbol, timeframe, from.getTime(), to.getTime());
        return bars;
    }
    async fetchBarsBefore(symbol, timeframe, before, limit, _chartId) {
        const tfMs = resolveTimeframeMs(timeframe);
        const count = limit ?? 1000;
        const fromTs = before.getTime() - count * tfMs;
        const bars = await this.provider.fetchBars(symbol, timeframe, fromTs, before.getTime());
        return bars;
    }
    subscribeToBar(symbol, timeframe, onBar) {
        return this.provider.subscribeBars(symbol, timeframe, onBar);
    }
    subscribeToTrades(_symbol, _onTrade) {
        return () => { };
    }
    subscribeToOrderbook(_symbol, _onUpdate) {
        return () => { };
    }
    async searchSymbols(query) {
        return this.provider.searchSymbols(query);
    }
}
